import { render, staticRenderFns } from "./ContentManagement.vue?vue&type=template&id=64ad2888&scoped=true"
import script from "./ContentManagement.vue?vue&type=script&lang=js"
export * from "./ContentManagement.vue?vue&type=script&lang=js"
import style0 from "./ContentManagement.vue?vue&type=style&index=0&id=64ad2888&prod&lang=css"
import style1 from "./ContentManagement.vue?vue&type=style&index=1&id=64ad2888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad2888",
  null
  
)

export default component.exports